<template>
    <Navbar></Navbar>
    <div class="product-detail-page">
        <div class="detail-banner">
            <div class="img-box detail-banner-img">
                <img src="/assets/product/electronics/s156-AM/s156-AM.jpg" alt="200-1-01">
            </div>
            <div class="detail-banner-r">

                <div class="detail-banner-t2">15.6 AMOLED车载中控显示屏</div>
                <div class="detail-banner-desc">

                    AMOLED车载屏，2.5K高分辨率，搭载ToE触控技术。
                </div>
            </div>
        </div>

        <div class="detail-center">
            <div class="detail-center-l">
                <div class="detail-text-box">
                    <div class="detail-title">产品说明</div>
                    <div class="detail-desc">
                        <div>
                            采用Tandem设计，亮度可达1000nits<br />
                        </div>
                        <div>
                            99% DCI-P3 色域<br />
                        </div>
                        <div>
                            Real 10bit 高色深<br />
                        </div>
                        <div>
                            超薄OLED屏，总成整体厚度仅5.5mm<br />
                        </div>
                        <div>
                            硬件级低蓝光护眼方案
                        </div>
                    </div>
                </div>

                <div class="one-titile">
                    核心配置
                </div>
                <div class="spec-row">
                    <div class="spec-image img-box">
                        <img src="/assets/product/electronics/s156-AM/s156-AM-1.jpg" alt="200-1-02">
                    </div>
                    <div class="spec-card">
                        <div class="spec-columns">
                            <div class="spec-title">
                                产品参数
                            </div>
                            <div class="spec-col">
                                <div class="spec-item">
                                    <div class="v">AMOLED</div>
                                    <div class="k">面板技术</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">ToE</div>
                                    <div class="k">触控技术</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">No Backlight</div>
                                    <div class="k">背光技术</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">2560 x 1440</div>
                                    <div class="k">分辨率</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">1000nits</div>
                                    <div class="k">亮度</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">1,000,000 : 1</div>
                                    <div class="k">对比度</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">99% DCI-P3</div>
                                    <div class="k">色域</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>



            </div>
        </div>
    </div>
    <Footer></Footer>
</template>

<script setup>
import Navbar from '@/components/Navbar.vue';
import Footer from '@/components/Footer.vue';
</script>

<script>
export const pageConfig = {
    title: '15.6 AMOLED车载中控显示屏 - 蜂巢汽车官网',
    keywords: '蜂巢,蜂巢汽车,发动机,变速箱,电子',
    description: '蜂巢汽车科技集团有限公司，是一家掌握从传统动力到混合动力再到纯电动力（含控制器）全领域动力总成、汽车智能化集成系统等核心技术的零部件企业，具备完整的软、硬件产业链；能为客户提供高效节能环保的汽车动力总成、智能化出行解决方案',
    outputPath: 'electronics/s156-AM.html'
};

import { createApp } from 'vue';
import App from './s156-AM.vue';
import store from '@/store/index';
import "@/assets/styles/global.scss";
import "@/assets/styles/transmission-200.scss";

function mountApp() {
    const appNode = document.getElementById('app');
    if (appNode) {
        if (appNode._vueApp) {
            appNode._vueApp.unmount();
            delete appNode._vueApp;
        }
        const app = createApp(App);
        app.use(store);
        appNode._vueApp = app.mount(appNode);
    }
}

document.addEventListener('DOMContentLoaded', mountApp);

if (module.hot) {
    module.hot.accept('./s156-AM.vue', () => {
        mountApp();
    });
}
</script>

<style lang="scss" scoped></style>
